import { appendReduxPart } from "infrastructure/store";

import { rolesSaga } from "./SecurityRole.saga";
import { roles } from "./SecurityRole.slice";

export * from "./SecurityRole.actions";
export * from "./SecurityRole.state";

appendReduxPart(
  {
    reducerName: roles.name,
    reducer: roles.reducer
  },
  rolesSaga()
);
